import { render, staticRenderFns } from "./RelatedMovementsViewer.vue?vue&type=template&id=cdfa4fe8&scoped=true&"
import script from "./RelatedMovementsViewer.vue?vue&type=script&lang=js&"
export * from "./RelatedMovementsViewer.vue?vue&type=script&lang=js&"
import style0 from "./RelatedMovementsViewer.vue?vue&type=style&index=0&id=cdfa4fe8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdfa4fe8",
  null
  
)

export default component.exports